<script setup>
// import { getClient } from '@/core/js/GraphqlClient.js';
import { GA } from '@/mixins/Ga';
import DiscountsPromoCodesListing from '@/components/discounts-listing/DiscountsPromoCodesListing.vue';
import BtnPill from '@/components/btn/BtnPill.vue';
import Colors from '@/config/Colors.json';

const props = defineProps({
    displayGroceryTitle: {
        type: Boolean,
        value: false,
    },
    displayLogos: {
        type: Boolean,
        value: false,
    },
    title: {
        type: String,
        default: '',
    },
    link: {
        type: String,
        default: '',
    },
    linkTitle: {
        type: String,
        default: '',
    },
    discounts: {
        type: Object,
        default: () => {},
    },
    groceries: {
        type: Object,
        default: () => {},
    },
    recipesQuantities: {
        type: Object,
        default: () => {},
    },
    displayPromoCodes: {
        type: Boolean,
        value: false,
    },
});
const ga = new GA({ category: 'discounts', action: 'clicExterne' });
const hasGroceryLogo = (discount) =>
    props.groceries[discount.grocery[0].id] &&
    props.groceries[discount.grocery[0].id].logo &&
    props.groceries[discount.grocery[0].id].logo[0] &&
    props.groceries[discount.grocery[0].id].logo[0].url;
const isSameGrocery = (discounts, index) => discounts[index - 1] && discounts[index - 1].grocery[0].id === discounts[index].grocery[0].id;
</script>

<template>
    <div
        v-if="discounts.length > 0"
        class="DiscountsListing__section"
    >
        <div
            v-if="title || link"
            class="DiscountsListing__header flex items-baseline"
        >
            <h3
                v-if="title"
                class="h4 mb-4"
            >
                {{ title }}
            </h3>

            <a
                v-if="link"
                class="ml-4 text-dark-yellow"
                :href="link"
                target="_blank"
                v-on:click="ga.send({ label: groceries[discount.grocery[0].id].title, camelCase: false })"
            >
                <Btn
                    size="small"
                    :up="true"
                    :text="linkTitle"
                    :color="Colors.dark.yellow"
                />
            </a>
        </div>

        <div
            v-if="displayPromoCodes"
            class="DiscountsListing__codes"
        >
            <DiscountsPromoCodesListing :grocery="groceries[discounts[0].grocery[0].id]" />
        </div>

        <div class="DiscountsListing__list group/list groupnot flex flex-wrap justify-between overflow-hidden">
            <a
                v-for="(discount, discountIndex) in discounts"
                :key="discount.id"
                class="mb-6 flex w-full items-start justify-between rounded-xl bg-dark-blue text-white md:w-[49%]"
                target="_blank"
                :href="discount.url"
            >
                <!-- <a
                v-for="(discount, discountIndex) in discounts"
                :key="discount.id"
                :class="{
                    'bg-dark-blue text-white': displayGroceryTitle,
                    'bg-white text-dark-blue': !displayGroceryTitle,
                }"
                class="mb-6 bg-dark-blue text-white flex w-full items-start justify-between rounded-xl md:w-[49%]"
                target="_blank"
                :href="discount.url"
            > -->
                <!-- <div
                    v-if="displayLogos && hasGroceryLogo(discount)"
                    class="DiscountsListing__logowrap flex w-3/12 shrink-0 grow-0 items-center justify-center self-stretch border-t-2 border-dark-blue/10 bg-white p-3 group-first/list:border-t-0 md:w-2/12"
                    :class="{
                        '!border-t-0': isSameGrocery(discounts, discountIndex),
                    }"
                >
                    <img
                        v-if="!isSameGrocery(discounts, discountIndex)"
                        class="-my-px"
                        :alt="groceries[discount.grocery[0].id].title"
                        :src="groceries[discount.grocery[0].id].logo[0].url"
                        loading="lazy"
                    >
                </div> -->
                <div
                    class="DiscountsListing__rightwrap flex w-full flex-wrap p-2 opacity-100 transition duration-500 group-first/list:border-t-0 can-hover:groupnot-hover:opacity-50"
                    :class="{
                        'border-dark-blue/10': !displayGroceryTitle,
                        'border-white/10': displayGroceryTitle,
                    }"
                >
                    <div class="DiscountsListing__infos mb-2 mt-4 flex w-full justify-between px-4 md:px-6">
                        <h5 class="DiscountsListing__name h5 mb-2 pr-5 text-sm transition duration-500">
                            {{ discount.title }}
                        </h5>
                        <div class="DiscountsListing__prize inline-block text-xl font-medium md:text-3xl">
                            {{ discount.prize }}<sup class="ml-1">$</sup>
                            <span
                                v-if="discount.unit"
                                class="DiscountsListing__unit align-normal block text-sm font-normal md:ml-1 md:inline xl:align-super"
                                >/{{ discount.unit }}</span
                            >
                        </div>
                    </div>
                    <div
                        v-if="displayGroceryTitle"
                        class="DiscountsListing__namewrap mb-6 w-full rounded-lg pr-4"
                    >
                        <div class="flex flex-col px-4 md:px-6">
                            <h5 class="text-lg">
                                <!-- <span class="inline-block border-b border-white my-1"> -->
                                {{ groceries[discount.grocery[0].id].title }}
                                <!-- </span> -->
                            </h5>
                        </div>
                    </div>
                    <div
                        v-if="discount.ingredients.length > 0 && recipesQuantities[discount.ingredients[0].id] > 0"
                        class="DiscountListing__pill -mt-2 w-full px-4 pb-4 md:px-6"
                    >
                        <BtnPill
                            class="!mb-0 !text-base font-bold"
                            :color="!displayGroceryTitle ? 'dark-blue' : 'light-blue'"
                            icon="whisk"
                            :to="{
                                name: 'recettes.' + lang,
                                params: {
                                    category: discount.ingredients[0].slug,
                                    id: discount.ingredients[0].id,
                                },
                            }"
                        >
                            <template #label>
                                <span class="md:hidden">Recettes inspirantes</span>
                                <span class="hidden md:inline">Voir les recettes utilisant cet ingrédient</span>
                            </template>
                        </BtnPill>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>
